module.exports = __webpack_public_path__ + "img/DE.dc93d7cc.webp";